import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { OrderService } from '../_ecomservices/order.service';
import { LoadingService } from '../../_services/loading.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit {

  displayedColumns: string[] = ['OrderID',  'OrderDate', 'Customer', 'BillAmount', 
    'ShippingStatus', 'OrderStatus', 'Action'];
  
    dataSource: MatTableDataSource<any>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    searchKey: string;

  constructor(
    private titleService: Title,
    public orderService: OrderService,
    private loading : LoadingService,
    public datePipe: DatePipe,
    private route: ActivatedRoute,) { }


    ngOnInit() {
      this.titleService.setTitle('Order List');
      this.onLoadOrders();
    }

    onLoadOrders() {
      //console.log('ok');
      var result = this.orderService.get_orders().subscribe(data=> {
        // console.log(data);
        this.dataSource = new MatTableDataSource<any>(data['orderList']);
        this.dataSource.paginator = this.paginator;
        this.loading.spin$.next(false);
      });
    }
  
    applyFilter() {
      this.dataSource.filter = this.searchKey.trim().toLocaleLowerCase();
    }
  
    onSearchClear() {
      this.searchKey = "";
      this.applyFilter();
    }


}
